(function () {
  'use strict';
  var racine = document.getElementById('quiz');
  if (!racine || racine.dataset.pret === '1') return;
  racine.dataset.pret = '1';

  var RDV = '/pages/admissions#candidature';
  
  

  var FACULTES = {
    f1: { nom: 'Faculté des études bibliques', ancre: '#fac-01' },
    f2: { nom: 'Faculté du ministère prophétique', ancre: '#fac-02' },
    f3: { nom: "Faculté d'Esther", ancre: '#fac-03' },
    f4: { nom: "Faculté de l'influence du Royaume", ancre: '#fac-04' },
    f5: { nom: 'Faculté du combat spirituel', ancre: '#fac-05' },
    f6: { nom: 'Faculté de la guérison intérieure', ancre: '#fac-06' },
    f7: { nom: "Faculté d'évangélisation", ancre: '#fac-07' },
    f8: { nom: 'Faculté de prédication', ancre: '#fac-08' }
  };

  /* programme phare de chaque faculté, et sa variante « débutant » */
  var PROGRAMMES = {
    f1: {
      nom: 'Maturité spirituelle pour une vie surnaturelle',
      texte: "Sortir d'une foi instable pour construire une vie spirituelle profonde, disciplinée et durable : prière, Parole, sanctification, caractère.",
      duree: '8 cours · 8 semaines', rentree: '10 septembre 2026', tarif: 'ess'
    },
    f2: {
      nom: 'Les fondements du ministère prophétique',
      texte: "Comprendre avant d'exercer : ce que dit la Bible du prophétisme, l'autorité spirituelle, et l'éthique sans laquelle un don devient dangereux.",
      duree: '8 cours · 8 semaines', rentree: '10 septembre 2026', tarif: 'pre'
    },
    f3: {
      nom: 'The Love Road®',
      texte: "Six dimensions de votre vie, une par semaine : spirituelle, émotionnelle, sociale, physique, mentale et financière. Le mariage se prépare bien avant la rencontre.",
      duree: 'Introduction + 6 modules · 7 semaines', rentree: '10 septembre 2026', tarif: 'pre'
    },
    f4: {
      nom: 'Leadership selon le Royaume',
      texte: "Le leadership commence par le service et tient par le caractère. Vision, décision, conflits, transmission : les compétences d'un responsable qui dure.",
      duree: '8 cours · 8 semaines', rentree: '10 septembre 2026', tarif: 'ess'
    },
    f5: {
      nom: 'Les fondements bibliques du combat spirituel',
      texte: "Comprendre le monde spirituel sans peur ni superstition : la victoire déjà acquise, les armes que la Bible décrit, le discernement au quotidien.",
      duree: '8 cours · 8 semaines', rentree: '10 septembre 2026', tarif: 'pre'
    },
    f6: {
      nom: 'Les fondements de la guérison intérieure',
      texte: "Comprendre avant de guérir : l'âme, les émotions, la mémoire, le pardon comme processus, et la construction d'un vrai parcours de restauration.",
      duree: '8 cours · 8 semaines', rentree: '10 septembre 2026', tarif: 'ess'
    },
    f7: {
      nom: 'Évangélisation, mission et influence',
      texte: "Le parcours le plus complet : des fondements au témoignage quotidien, de l'influence dans la société à la mission, jusqu'à faire des disciples.",
      duree: '18 cours · 18 semaines', rentree: '10 septembre 2026', tarif: 'pre'
    },
    f8: {
      nom: 'Prêcher la Parole avec excellence',
      texte: "Construire un message biblique, développer votre voix et votre présence, capter l'attention — jusqu'à présenter une prédication complète.",
      duree: '15 cours · 15 semaines', rentree: '10 septembre 2026', tarif: 'pre'
    }
  };

  var TARIFS = {
    ess:     { prix: '99,75 € par mois',  note: 'pendant 4 mois, ou 399 € en une fois', lien: RDV },
    pre:     { prix: '124,75 € par mois', note: 'pendant 4 mois, ou 499 € en une fois', lien: RDV },
    fac:     { prix: '324,75 € par mois', note: 'ou 1 299 € en une fois', lien: RDV }
  };

  var etapes   = racine.querySelectorAll('.quiz__etape');
  var barre    = document.getElementById('quizBarre');
  var compteur = document.getElementById('quizCompteur');
  var retour   = document.getElementById('quizRetour');
  var res      = document.getElementById('quizRes');
  var pied     = racine.querySelector('.quiz__pied');

  var courante = 0;
  var scores   = { f1:0, f2:0, f3:0, f4:0, f5:0, f6:0, f7:0, f8:0 };
  var historique = [];
  var rythme = 'normal', budget = 'programme';

  function afficher(i) {
    etapes.forEach(function (e, n) { e.classList.toggle('actif', n === i); });
    barre.style.width = ((i / etapes.length) * 100) + '%';
    compteur.textContent = (i + 1) + ' / ' + etapes.length;
    retour.hidden = (i === 0);
  }

  racine.querySelectorAll('.quiz__c').forEach(function (b) {
    b.addEventListener('click', function () {
      var gagnes = {};
      (b.dataset.pts || '').split(',').forEach(function (p) {
        if (!p) return;
        var x = p.split(':');
        scores[x[0]] = (scores[x[0]] || 0) + parseInt(x[1], 10);
        gagnes[x[0]] = parseInt(x[1], 10);
      });
      if (b.dataset.rythme) rythme = b.dataset.rythme;
      if (b.dataset.budget) budget = b.dataset.budget;
      historique.push(gagnes);

      courante++;
      if (courante >= etapes.length) { terminer(); }
      else { afficher(courante); racine.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  retour.addEventListener('click', function () {
    if (courante === 0) return;
    courante--;
    var g = historique.pop() || {};
    Object.keys(g).forEach(function (k) { scores[k] -= g[k]; });
    afficher(courante);
  });

  function classement() {
    return Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; });
  }

  function remplir(cle) {
    var p = PROGRAMMES[cle];
    var f = FACULTES[cle];
    var t = TARIFS[p.tarif];

    document.getElementById('recoFac').textContent = f.nom;
    document.getElementById('recoNom').textContent = p.nom;
    document.getElementById('recoTexte').textContent = p.texte;
    document.getElementById('recoMeta').innerHTML =
      '<span><b>Durée</b>' + p.duree + '</span>' +
      '<span><b>Rentrée</b>' + p.rentree + '</span>' +
      '<span><b>Rythme conseillé</b>' + (rythme === 'leger' ? 'un cours toutes les deux semaines' : 'un cours par semaine') + '</span>';
    document.getElementById('recoPrix').innerHTML =
      t.prix + '<small>' + t.note + '</small>';
    document.getElementById('recoLien').href = t.lien;
    document.getElementById('recoLien').textContent =
      'Réserver mon entretien';
    document.getElementById('recoDetail').href = '/pages/facultes' + f.ancre;
  }

  function terminer() {
    var ordre = classement();
    var principale = ordre[0];

    remplir(principale);

    var alternatives = [
      { cle: ordre[1], prog: PROGRAMMES[ordre[1]] },
      { cle: ordre[2], prog: PROGRAMMES[ordre[2]] }
    ];

    document.getElementById('recoAutres').innerHTML = alternatives.map(function (a) {
      var t = TARIFS[a.prog.tarif];
      return '<div class="autre"><div><b>' + a.prog.nom + '</b>' +
             '<span>' + FACULTES[a.cle].nom + ' · ' + t.prix + '</span></div>' +
             '<a href="/pages/facultes' + FACULTES[a.cle].ancre + '">Découvrir →</a></div>';
    }).join('');

    /* si le visiteur vise une faculté entière, on l'oriente vers le parcours complet */
    if (budget === 'faculte') {
      document.getElementById('recoAutres').insertAdjacentHTML('beforeend',
        '<div class="autre"><div><b>Parcours complet de ' + FACULTES[principale].nom + '</b>' +
        '<span>Tous les programmes de la faculté · à partir de 324,75 € par mois</span></div>' +
        '<a href="/pages/admissions#frais">Voir les frais →</a></div>');
    }

    etapes.forEach(function (e) { e.classList.remove('actif'); });
    pied.style.display = 'none';
    barre.style.width = '100%';
    res.classList.add('actif');
    racine.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.getElementById('quizRefaire').addEventListener('click', function () {
    courante = 0; historique = [];
    Object.keys(scores).forEach(function (k) { scores[k] = 0; });
    rythme = 'normal'; budget = 'programme';
    res.classList.remove('actif');
    pied.style.display = '';
    afficher(0);
    racine.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  afficher(0);
})();